import { z } from 'zod'
import {
  eventDataSchema,
  refinementWithMessage,
  testStringAgainstRegex,
  zodString,
} from '../common.schema'

export const AbtestSchema = z.object({
  event: z.literal('abtest'),

  event_data: eventDataSchema.extend({
    action: zodString.refine(
      testStringAgainstRegex(/^[a-zA-Z0-9_|/-]+$/),
      refinementWithMessage(
        'value must be lowercase, only `_|/-` special characters are allowed',
      ),
    ),
  }),
})

export type AbtestEvent = z.infer<typeof AbtestSchema>
